import React from 'react';
import { Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import EmbedCodeBlock from '@/components/Chat/EmbedCodeBlock';

interface EmbedShareModalProps {
  opened: boolean;
  onClose: () => void;
  /** 分享页 URL */
  shareLink: string;
  /** 嵌入脚本来源 host */
  baseHost: string;
}

/**
 * 分享页 iframe 嵌入代码弹窗
 *
 * 在 SaaS 个人模式 Popover 内通过"嵌入到网站"按钮触发，
 * 用独立 Modal 承载嵌入代码生成器，避免 Popover 高度撑爆。
 */
export const EmbedShareModal: React.FC<EmbedShareModalProps> = ({ opened, onClose, shareLink, baseHost }) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text fw={600} fz={18}>
          {t('shareSetting.embed.title', '嵌入到网站')}
        </Text>
      }
      size="lg"
      centered
    >
      <EmbedCodeBlock shareLink={shareLink} baseHost={baseHost} showHeader={false} />
    </Modal>
  );
};

export default EmbedShareModal;
